export const FORM_STATE_ENTITIES = {
    CLAIM: 'claim',
    INCIDENT: 'incident',
    CONTROL: 'control',
    CONTROL_ACTIVITY: 'controlActivity',
    MSPR_PROVIDER: 'msprProvider',
    MSPR_GOVERNANCE_CHECK: 'msprGovernanceCheck',
    OBLIGATION: 'obligation',
    COMPLAINT: 'complaint',
    RISK: 'risk',
    RISK_APPETITE_STATEMENT: 'riskAppetiteStatement',
    CONTROL_TEST: 'controlTest',
    TASK: 'task',
    CONFLICT_OF_INTEREST: 'conflictOfInterest',
    SUPPLIER: 'supplier',
    SUPPLIER_CONTACT: 'supplierContact',
    HANDLING_PARTY: 'handlingParty',
    EXCESS: 'excess',
    PRODUCT_TYPE: 'productType',
} as const;

export type FormStateEntity = (typeof FORM_STATE_ENTITIES)[keyof typeof FORM_STATE_ENTITIES];

/**
 * Helper array of all FormStateEntity values.
 * Useful for runtime validation (e.g. Zod enum creation).
 */
export const FORM_STATE_ENTITY_KEYS = Object.values(FORM_STATE_ENTITIES);

/**
 * Entity types that can be detected in navigation queries.
 * These are the entities users can ask "where can I add a new X?" about.
 * Used by the AI navigation tool to detect entity types from natural language.
 */
export const NAVIGATION_ENTITY_TYPES = [
    'complaint',
    'claim',
    'incident',
    'obligation',
    'control',
    'risk',
    'task',
    'training',
    'user',
    'product',
] as const;

export type NavigationEntityType = (typeof NAVIGATION_ENTITY_TYPES)[number];

/**
 * Map common synonyms to canonical entity names for navigation detection.
 * LLM uses this context, and keyword fallback also uses it.
 */
export const NAVIGATION_ENTITY_SYNONYMS: Record<string, NavigationEntityType> = {
    // Complaints
    complaint: 'complaint',
    complaints: 'complaint',
    grievance: 'complaint',
    grievances: 'complaint',
    // Claims
    claim: 'claim',
    claims: 'claim',
    // Incidents
    incident: 'incident',
    incidents: 'incident',
    breach: 'incident',
    breaches: 'incident',
    // Obligations
    obligation: 'obligation',
    obligations: 'obligation',
    // Controls
    control: 'control',
    controls: 'control',
    // Risks
    risk: 'risk',
    risks: 'risk',
    // Tasks
    task: 'task',
    tasks: 'task',
    // Training
    training: 'training',
    // Users
    user: 'user',
    users: 'user',
    accounts: 'user',
    staff: 'user',
    team: 'user',
    personnel: 'user',
    permissions: 'user',
    // Products
    product: 'product',
    products: 'product',
};
